import type { IWarehouse, Nullable } from '@nova/core';

import type { CheckoutEventContextPayload } from './events';

export interface CheckoutAnalyticsEventContextSource {
  warehouse: Nullable<Partial<IWarehouse>>;
  appointmentId: Nullable<string>;
  assetVisitId: Nullable<string>;
}

/**
 * Builds the context shared by every Juno checkout event.
 *
 * Pure, so the payload shape is testable without mounting a view. The warehouse and org keys
 * are always present — as `undefined` before the warehouse request resolves, which Mixpanel
 * drops on serialization — while the appointment and asset visit ids are only added once the
 * validation step has produced them. Both details are preserved from the untyped
 * `useTrackJunoEvent` this replaced.
 */
export function buildCheckoutAnalyticsEventContext({
  warehouse,
  appointmentId,
  assetVisitId
}: CheckoutAnalyticsEventContextSource): CheckoutEventContextPayload {
  return {
    warehouse_id: warehouse?.id,
    warehouse_name: warehouse?.name,
    org_id: warehouse?.org?.id,
    org_name: warehouse?.org?.name,
    ...(appointmentId ? { appointment_id: appointmentId } : {}),
    ...(assetVisitId ? { asset_visit_id: assetVisitId } : {})
  };
}
